import {DialogActions, DialogContent, Typography} from '@mui/material';
import {bool, func, string} from 'prop-types';
import styled from 'styled-components';

import {FONT_FAMILIES} from '../../const';
import BoldText from '../form/BoldText';
import Button from '../form/buttons/Button/Button';
import BaseModal from '../modal/BaseModal';

const DeleteUserModal = ({isOpen, onSubmit, username, onCancel, entity}) => {
  return (
    <BaseModal onClose={onCancel} title="Supprimer un utilisateur" open={isOpen}>
      <DialogContent sx={{p: 3}}>
        <Typography>
          Vous êtes sur le point de supprimer <BoldText>{username}</BoldText> de {entity}.
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button variant="outlined" color="error" onClick={onCancel}>
          Annuler
        </Button>
        <Button variant="contained" color="error" onClick={onSubmit}>
          Supprimer l'utilisateur
        </Button>
      </DialogActions>
    </BaseModal>
  );
};

DeleteUserModal.propTypes = {
  isOpen: bool.isRequired,
  onSubmit: func.isRequired,
  onCancel: func.isRequired,
  username: string.isRequired,
  entity: string.isRequired
};

export default DeleteUserModal;
